import { useEffect, useState } from 'react';

export default function useIsOutOfView(
  elementRef: React.RefObject<HTMLElement>,
  rootMargin?: string
) {
  const [isOutOfView, setIsOutOfView] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;

        setIsOutOfView(!entry.isIntersecting);
      },
      { rootMargin }
    );

    if (elementRef.current) observer.observe(elementRef.current);

    return () => observer.disconnect();
  }, [elementRef, rootMargin]);

  return isOutOfView;
}
